<template>
  <!--
    このコンポーネントの責務は、ListboxOption に共通のスタイルをつけるだけである。
    本来はシンプルに value は呼び出す側からそのまま渡したかった。
    しかし、ここで value prop を定義せず、さらに :value="value" を書かなかった場合、
    ライブラリ側の value のデフォルト値 false が優先的に使われてしまう。
    それ回避するためにここで明示的に value を渡している。
  -->
  <ListboxOption
    class="hover:bg-gray-200 cursor-pointer p-2 w-full break-words whitespace-pre-wrap"
    style="line-height: 115%;"
    :value="value"
  >
    <slot />
  </ListboxOption>
</template>

<script lang="ts">
import { ListboxOption } from '@headlessui/vue';
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  name: 'BaseSelectOption',
  components: {
    ListboxOption,
  },
  props: {
    value: {
      type: [Object, String, Number, Boolean] as PropType<Record<number | string | symbol, unknown> | string | number | boolean>,
      default: undefined,
    },
  },
});
</script>
